export function logDebug(...args: any[]) {
    if (import.meta.env.DEV) {
        console.log(...args);
    }
}
